'use strict';

/* ─────────────────────────────────────────────────────────────
   GREYLINE PERFORMANCE — DX Console
   File: assets/dxconsole.js

   CONFIG: Set WORKER_BASE to your Cloudflare Worker URL.
   Worker deploy instructions: see cloudflare-worker.js
   ───────────────────────────────────────────────────────────── */

const CONFIG = {
  WORKER_BASE:  'https://gl-dxproxy.flagpoleantennas.workers.dev',  // ← YOUR WORKER URL HERE
  CLUBLOG_KEY:  'YOUR_CLUBLOG_API_KEY',                      // ← clublog.org/api
  DEFAULT_CALL: 'KL2A',
  SPOTS_INTERVAL:   60_000,
  PROP_INTERVAL:   300_000,
  RBN_INTERVAL:     90_000,
  DXW_INTERVAL:  3_600_000,
  NL_INTERVAL:  86_400_000,
  CAL_INTERVAL: 86_400_000,
  PSK_INTERVAL:    120_000,
};

const STATE = { callsign: CONFIG.DEFAULT_CALL, band: 'all', mode: 'all' };

/* ── UTILITIES ───────────────────────────────────────────── */
const $ = id => document.getElementById(id);

function setDot(dotId, cls) {
  const el = $(dotId);
  if (el) el.className = 'gl-dot ' + (cls || '');
}

function freqToBand(mhz) {
  const f = parseFloat(mhz);
  if (f >= 28   && f < 30)  return '10';
  if (f >= 24   && f < 25)  return '12';
  if (f >= 21   && f < 22)  return '15';
  if (f >= 18   && f < 19)  return '17';
  if (f >= 14   && f < 15)  return '20';
  if (f >= 7    && f < 8)   return '40';
  if (f >= 3.5  && f < 4)   return '80';
  if (f >= 1.8  && f < 2)   return '160';
  return '?';
}

function spotMode(comment) {
  const c = (comment || '').toUpperCase();
  if (/FT8|FT4|DIGI/.test(c)) return 'FT8';
  if (/SSB|PH|AM|FM/.test(c)) return 'SSB';
  return 'CW';
}

function inferMode(name) {
  const n = name.toUpperCase();
  if (/RTTY/.test(n))        return 'rtty';
  if (/FT[48]|DIGI/.test(n)) return 'ft8';
  if (/\bCW\b/.test(n))      return 'cw';
  if (/SSB|PHONE/.test(n))   return 'ssb';
  return 'mix';
}

function stripHtml(html) {
  const d = document.createElement('div');
  d.innerHTML = html;
  return d.textContent || '';
}

function utcHHMM(dateStr) {
  const d = new Date(dateStr);
  if (isNaN(d)) return '—';
  return String(d.getUTCHours()).padStart(2,'0') + String(d.getUTCMinutes()).padStart(2,'0') + 'z';
}

function regionColor(region) {
  const map = { NA:'var(--green)', EU:'var(--blue)', JA:'var(--amber)', AS:'var(--amber)', OC:'var(--teal)', SA:'var(--teal)' };
  return map[region] || 'var(--muted)';
}

/* ── UTC CLOCK ───────────────────────────────────────────── */
(function clock() {
  const el = $('gl-utc');
  if (!el) return;
  const tick = () => {
    const n = new Date();
    const p = v => String(v).padStart(2,'0');
    el.textContent = p(n.getUTCHours()) + ':' + p(n.getUTCMinutes()) + ':' + p(n.getUTCSeconds()) + ' UTC';
  };
  tick();
  setInterval(tick, 1000);
})();

/* ── CONTROL BAR ─────────────────────────────────────────── */
document.querySelectorAll('[data-band]').forEach(el => {
  el.addEventListener('click', () => {
    document.querySelectorAll('[data-band]').forEach(p => p.classList.remove('active'));
    el.classList.add('active');
    STATE.band = el.dataset.band;
    renderSpots();
  });
});

document.querySelectorAll('[data-mode]').forEach(el => {
  el.addEventListener('click', () => {
    document.querySelectorAll('[data-mode]').forEach(p => p.classList.remove('active'));
    el.classList.add('active');
    STATE.mode = el.dataset.mode;
    renderSpots();
  });
});

let callDebounce;
const csInput = $('gl-cs');
if (csInput) {
  csInput.addEventListener('input', e => {
    clearTimeout(callDebounce);
    callDebounce = setTimeout(() => {
      STATE.callsign = e.target.value.toUpperCase().trim() || CONFIG.DEFAULT_CALL;
      loadRbn();
      loadPsk();
      loadClubLog();
      updatePskLink();
    }, 600);
  });
}

function updatePskLink() {
  const btn = $('gl-psk-map-btn');
  if (btn) btn.href = `https://pskreporter.info/pskmap.html?preset&callsign=${STATE.callsign}&mode=CW&period=3600`;
}

/* ── DX SUMMIT SPOTS ─────────────────────────────────────── */
let ALL_SPOTS = [];

async function loadSpots() {
  try {
    const r = await fetch('https://www.dxsummit.fi/api/v1/spots?limit=50');
    if (!r.ok) throw new Error(r.status);
    ALL_SPOTS = await r.json();
    renderSpots();
    setDot('gl-spots-dot', '');
    const st = $('gl-spots-st'); if (st) st.textContent = 'LIVE';
  } catch {
    try {
      const r2 = await fetch(CONFIG.WORKER_BASE + '/proxy/spots?limit=50');
      if (!r2.ok) throw new Error(r2.status);
      ALL_SPOTS = await r2.json();
      renderSpots();
      setDot('gl-spots-dot', '');
    } catch {
      setDot('gl-spots-dot', 'off');
      const el = $('gl-spot-list');
      if (el) el.innerHTML = `<div class="gl-error">Spots offline — <a href="https://www.dxsummit.fi" target="_blank" style="color:var(--gold)">dxsummit.fi ↗</a></div>`;
    }
  }
}

function renderSpots() {
  const el = $('gl-spot-list');
  if (!el) return;
  let spots = ALL_SPOTS;
  if (STATE.band !== 'all') spots = spots.filter(s => freqToBand(s.frequency) === STATE.band);
  if (STATE.mode !== 'all') spots = spots.filter(s => spotMode(s.comment) === STATE.mode);
  if (!spots.length) { el.innerHTML = '<div class="gl-loading">No spots match current filter</div>'; return; }
  el.innerHTML = spots.slice(0, 12).map(s => {
    const band = freqToBand(s.frequency);
    const freq = parseFloat(s.frequency).toFixed(3);
    const call = (s.dx_call || '').toUpperCase();
    const de   = 'de ' + (s.de_call || '').toUpperCase();
    const cmt  = stripHtml(s.comment || '');
    const time = utcHHMM(s.time || s.spotted_at || '');
    return `<div class="gl-spot">
      <span class="gl-s-freq">${freq}</span>
      <span class="gl-s-band band-${band}">${band}M</span>
      <span class="gl-s-call">${call}</span>
      <span class="gl-s-de">${de}</span>
      <span class="gl-s-cmt">${cmt}</span>
      <span class="gl-s-time">${time}</span>
    </div>`;
  }).join('');
}

/* ── PROPAGATION ─────────────────────────────────────────── */
async function loadProp() {
  const el = $('gl-prop-body');
  if (!el) return;
  try {
    const r = await fetch(CONFIG.WORKER_BASE + '/proxy/solar');
    if (!r.ok) throw new Error(r.status);
    const xml  = await r.text();
    const doc  = new DOMParser().parseFromString(xml, 'text/xml');
    const get  = tag => doc.querySelector(tag)?.textContent?.trim() || '—';
    const sfi  = get('solarflux');
    const ai   = get('aindex');
    const ki   = get('kindex');
    const xray = get('xray');
    const upd  = get('updated');

    const sfiBadge = $('gl-sfi-hdr');
    if (sfiBadge) sfiBadge.textContent = `SFI ${sfi}`;

    const col = (val, t, c) => { const v = parseFloat(val); for (let i=0;i<t.length;i++) if(v<=t[i]) return c[i]; return c[c.length-1]; };
    const sfiC = col(sfi, [80,120,300], ['var(--red)','var(--amber)','var(--green)']);
    const aiC  = col(ai,  [7,20,50],   ['var(--green)','var(--amber)','var(--red)','var(--red)']);
    const kiC  = col(ki,  [2,4,6],     ['var(--green)','var(--amber)','var(--red)','var(--red)']);
    const sfin = parseFloat(sfi), kin = parseFloat(ki);
    const forecast = [
      { b:'10', ok: sfin>120 && kin<4 },
      { b:'12', ok: sfin>120 && kin<4 },
      { b:'15', ok: sfin>100 && kin<5 },
      { b:'17', ok: sfin>90  && kin<5 },
      { b:'20', ok: sfin>90  && kin<6 },
      { b:'40', ok: kin<3 },
    ].map(f => `<span class="gl-bf-tag band-${f.b}">${f.b}M ${f.ok?'▲':'▼'}</span>`).join('');
    const condText  = kin<=2&&sfin>130 ? 'GOOD — HIGH BANDS' : kin<=3&&sfin>100 ? 'FAIR — MID BANDS' : kin>=5 ? 'DISTURBED' : 'MARGINAL';
    const condColor = kin<=2&&sfin>130 ? 'var(--green)' : kin<=3 ? 'var(--amber)' : 'var(--red)';

    el.innerHTML = `
      <div class="gl-prop-grid">
        <div class="gl-pc"><div class="gl-pc-label">SFI</div><div class="gl-pc-val" style="color:${sfiC}">${sfi}</div><div class="gl-pc-bar"><div class="gl-pc-fill" style="width:${Math.min(100,(sfin/300)*100).toFixed(0)}%;background:${sfiC}"></div></div></div>
        <div class="gl-pc"><div class="gl-pc-label">A-INDEX</div><div class="gl-pc-val" style="color:${aiC}">${ai}</div><div class="gl-pc-bar"><div class="gl-pc-fill" style="width:${Math.min(100,parseFloat(ai))}%;background:${aiC}"></div></div></div>
        <div class="gl-pc"><div class="gl-pc-label">K-INDEX</div><div class="gl-pc-val" style="color:${kiC}">${ki}</div><div class="gl-pc-bar"><div class="gl-pc-fill" style="width:${Math.min(100,(kin/9)*100).toFixed(0)}%;background:${kiC}"></div></div></div>
        <div class="gl-pc"><div class="gl-pc-label">X-FLUX</div><div class="gl-pc-val" style="color:var(--text)">${xray}</div><div class="gl-pc-bar"><div class="gl-pc-fill" style="width:10%;background:var(--green)"></div></div></div>
      </div>
      <div class="gl-cond-strip"><span class="gl-mini-label">CONDITIONS</span><span style="font-family:'JetBrains Mono',monospace;font-size:.72rem;color:${condColor}">${condText}</span></div>
      <div><div class="gl-mini-label" style="margin-bottom:.3rem">BAND FORECAST</div><div class="gl-band-forecast">${forecast}</div></div>
      <div style="font-family:'JetBrains Mono',monospace;font-size:.57rem;color:var(--dim);margin-top:.15rem">Updated: ${upd}</div>`;
  } catch {
    el.innerHTML = '<div class="gl-error">Solar data unavailable — configure Worker /proxy/solar</div>';
  }
}

/* ── RBN ─────────────────────────────────────────────────── */
async function loadRbn() {
  const el = $('gl-rbn-body');
  if (!el) return;
  const call = STATE.callsign;
  try {
    const r = await fetch(`${CONFIG.WORKER_BASE}/proxy/rbn?call=${call}&limit=10`);
    if (!r.ok) throw new Error(r.status);
    const data = await r.json();
    setDot('gl-rbn-dot', '');
    const st = $('gl-rbn-st'); if (st) st.textContent = 'LIVE';
    if (!data.length) { el.innerHTML = `<div class="gl-loading">No RBN spots for ${call}</div>`; return; }
    const hdr = `<div class="gl-rbn-hdr">
      <span class="gl-rbn-h" style="min-width:74px">Spotter</span>
      <span class="gl-rbn-h" style="min-width:60px">Freq</span>
      <span class="gl-rbn-h" style="flex:1">DX</span>
      <span class="gl-rbn-h" style="min-width:32px;text-align:right">dB</span>
      <span class="gl-rbn-h" style="min-width:42px;text-align:right">WPM</span>
    </div>`;
    el.innerHTML = hdr + data.slice(0,8).map(s => {
      const db = parseFloat(s.snr);
      const dbC = db>=15 ? 'var(--green)' : db>=6 ? 'var(--amber)' : 'var(--red)';
      return `<div class="gl-rr">
        <span class="gl-r-sp">${s.spotter||'—'}</span>
        <span class="gl-r-f">${parseFloat(s.freq).toFixed(3)}</span>
        <span class="gl-r-dx">${s.dx||call}</span>
        <span class="gl-r-db" style="color:${dbC}">${db>0?'+':''}${db}</span>
        <span class="gl-r-w">${s.speed||'—'} wpm</span>
      </div>`;
    }).join('');
  } catch {
    setDot('gl-rbn-dot', 'off');
    el.innerHTML = `<div style="font-family:'JetBrains Mono',monospace;font-size:.65rem;color:var(--muted);padding:.4rem 0">
      Worker /proxy/rbn not configured.<br>
      <a href="https://www.reversebeacon.net/dxsd1/sk.php?de=${call}" target="_blank" rel="noopener" style="color:var(--gold)">Open RBN direct for ${call} ↗</a>
    </div>`;
  }
}

/* ── DX-WORLD ────────────────────────────────────────────── */
async function loadDxWorld() {
  const el = $('gl-dxw-body');
  if (!el) return;
  try {
    const r = await fetch(CONFIG.WORKER_BASE + '/proxy/dxworld');
    if (!r.ok) throw new Error(r.status);
    const items = await r.json();
    setDot('gl-dxw-dot', '');
    el.innerHTML = items.slice(0,6).map(it => `
      <div class="gl-dw-item">
        <div><span class="gl-dw-call">${it.call||''}</span><span class="gl-dw-loc">${it.title||''}</span></div>
        <div class="gl-dw-meta">${it.date||''}</div>
        <div class="gl-dw-snip">${it.snippet||''}</div>
      </div>`).join('') || '<div class="gl-loading">No items</div>';
  } catch {
    setDot('gl-dxw-dot', 'off');
    el.innerHTML = `<div style="font-family:'JetBrains Mono',monospace;font-size:.65rem;color:var(--muted);padding:.25rem 0">
      Worker /proxy/dxworld not configured.<br>
      <a href="https://www.dx-world.net" target="_blank" rel="noopener" style="color:var(--gold)">Visit DX-World.net ↗</a>
    </div>`;
  }
}

/* ── AR NEWSLINE ─────────────────────────────────────────── */
async function loadNewsline() {
  const el = $('gl-nl-body');
  if (!el) return;
  try {
    const r = await fetch(CONFIG.WORKER_BASE + '/proxy/newsline');
    if (!r.ok) throw new Error(r.status);
    const items = await r.json();
    el.innerHTML = items.slice(0,3).map(it => `
      <div class="gl-nl-item">
        <div><span class="gl-nl-rpt">${it.report||''}</span><span class="gl-nl-date">${it.date||''}</span></div>
        <div class="gl-nl-headlines">${it.headlines||''}</div>
        <div class="gl-nl-links">
          ${it.script ? `<a class="gl-nl-link" href="${it.script}" target="_blank" rel="noopener">SCRIPT ↗</a>` : ''}
          ${it.audio  ? `<a class="gl-nl-link" href="${it.audio}"  target="_blank" rel="noopener">▶ AUDIO</a>` : ''}
        </div>
      </div>`).join('') || '<div class="gl-loading">No items</div>';
  } catch {
    el.innerHTML = `<div style="font-family:'JetBrains Mono',monospace;font-size:.65rem;color:var(--muted);padding:.25rem 0">
      Worker not configured.<br>
      <a href="https://www.arnewsline.org" target="_blank" rel="noopener" style="color:var(--gold)">Visit AR Newsline ↗</a>
    </div>`;
  }
}

/* ── CONTEST CALENDAR ────────────────────────────────────── */
async function loadContests() {
  const el = $('gl-cal-body');
  if (!el) return;
  try {
    const r = await fetch(CONFIG.WORKER_BASE + '/proxy/contests');
    if (!r.ok) throw new Error(r.status);
    const data = await r.json();
    let html = '';
    data.weeks.forEach(week => {
      html += `<div class="gl-week-hdr">${week.label}</div>`;
      week.contests.forEach(c => {
        const m = inferMode(c.name);
        html += `<div class="gl-ct">
          <span class="gl-ct-time">${c.time}</span>
          <span class="gl-ct-name">${c.name}</span>
          <span class="gl-ct-mode mode-${m}">${m==='mix'?'MIX':m.toUpperCase()}</span>
        </div>`;
      });
    });
    el.innerHTML = html || '<div class="gl-loading">No contests found</div>';
  } catch {
    el.innerHTML = renderStaticContests();
  }
}

function renderStaticContests() {
  // Static fallback — update periodically if Worker is down
  const weeks = [
    { label: 'WEEK OF APR 14–20', contests: [
      { time: 'Apr 15 · 0030Z', name: 'NAQCC CW Sprint', m: 'cw' },
      { time: 'Apr 18 · 0600Z', name: 'Worked All Provinces of China DX', m: 'mix' },
      { time: 'Apr 18 · 0900Z', name: 'CQMM DX Contest', m: 'cw' },
      { time: 'Apr 18 · 1600Z', name: 'Michigan QSO Party', m: 'mix' },
      { time: 'Apr 18 · 2100Z', name: 'World Wide Holyland Contest', m: 'mix' },
      { time: 'Apr 19 · 1800Z', name: 'ARRL Rookie Roundup, SSB', m: 'ssb' },
    ]},
    { label: 'WEEK OF APR 21–27', contests: [
      { time: 'Apr 22 · 0000Z', name: 'SKCC Sprint', m: 'cw' },
      { time: 'Apr 25 · 1200Z', name: 'UK/EI DX Contest, CW', m: 'cw' },
      { time: 'Apr 25 · 1200Z', name: 'SP DX RTTY Contest', m: 'rtty' },
      { time: 'Apr 25 · 1300Z', name: 'Helvetia Contest', m: 'mix' },
      { time: 'Apr 25 · 1600Z', name: 'Florida QSO Party', m: 'mix' },
      { time: 'Apr 27 · 1900Z', name: 'RSGB FT4 Contest', m: 'ft8' },
    ]},
    { label: 'WEEK OF APR 28 – MAY 4', contests: [
      { time: 'May 3 · 0000Z', name: 'ARI International DX Contest', m: 'mix' },
      { time: 'May 3 · 1200Z', name: 'New England QSO Party', m: 'mix' },
      { time: 'May 3 · 1200Z', name: 'Indiana QSO Party', m: 'mix' },
    ]},
  ];
  return weeks.map(w => `
    <div class="gl-week-hdr">${w.label}</div>
    ${w.contests.map(c=>`<div class="gl-ct">
      <span class="gl-ct-time">${c.time}</span>
      <span class="gl-ct-name">${c.name}</span>
      <span class="gl-ct-mode mode-${c.m}">${c.m==='mix'?'MIX':c.m.toUpperCase()}</span>
    </div>`).join('')}`).join('');
}

/* ── PSKREPORTER ─────────────────────────────────────────── */
async function loadPsk() {
  const heardEl   = $('gl-psk-heard');
  const hearingEl = $('gl-psk-hearing');
  const call = STATE.callsign;
  updatePskLink();
  try {
    const r = await fetch(`${CONFIG.WORKER_BASE}/proxy/psk?call=${call}&hours=1`);
    if (!r.ok) throw new Error(r.status);
    const data = await r.json();
    setDot('gl-psk-dot', '');
    const mkChip = (c, region) => {
      const col = regionColor(region);
      return `<span class="gl-chip" style="background:var(--dim);border:1px solid ${col.replace(')',',0.35)').replace('var','rgba').replace('(--','(')};color:${col}">${c}${region?' ('+region+')':''}</span>`;
    };
    if (heardEl)   heardEl.innerHTML   = (data.heardBy||[]).map(x=>mkChip(x.call,x.region)).join('') || '<span style="color:var(--muted);font-size:.7rem">None in last hour</span>';
    if (hearingEl) hearingEl.innerHTML = (data.hearing||[]).map(x=>mkChip(x.call,x.region)).join('') || '<span style="color:var(--muted);font-size:.7rem">None in last hour</span>';
  } catch {
    setDot('gl-psk-dot', 'off');
    if (heardEl) heardEl.innerHTML = `<a href="https://pskreporter.info/pskmap.html?preset&callsign=${call}&mode=CW&period=3600" target="_blank" rel="noopener" style="color:var(--gold);font-size:.65rem;font-family:monospace">Open PSKReporter map for ${call} ↗</a>`;
    if (hearingEl) hearingEl.innerHTML = '';
  }
}

/* ── CLUB LOG ────────────────────────────────────────────── */
async function loadClubLog() {
  const call = STATE.callsign;
  const msg  = $('gl-cl-msg');
  if (!CONFIG.CLUBLOG_KEY || CONFIG.CLUBLOG_KEY === 'YOUR_CLUBLOG_API_KEY') {
    if (msg) msg.textContent = 'Club Log API key not configured';
    return;
  }
  setDot('gl-cl-dot', 'amber');
  const st = $('gl-cl-st'); if (st) st.textContent = 'LOADING';
  try {
    const r = await fetch(`https://clublog.org/logsearch/api?call=${call}&api=${CONFIG.CLUBLOG_KEY}&list=dxcc`);
    if (!r.ok) throw new Error(r.status);
    const data = await r.json();
    const w = $('gl-cl-w'); if (w) w.textContent = data.worked    || '—';
    const c = $('gl-cl-c'); if (c) c.textContent = data.confirmed || '—';
    if (msg) msg.textContent = `${call} · ${data.confirmed||'—'} DXCC confirmed`;
    setDot('gl-cl-dot', '');
    if (st) st.textContent = 'LOADED';
  } catch {
    if (msg) msg.textContent = 'Club Log unavailable';
    setDot('gl-cl-dot', 'off');
    if (st) st.textContent = 'ERROR';
  }
}

/* ── INIT ────────────────────────────────────────────────── */
function loop(fn, interval) { fn(); setInterval(fn, interval); }

loop(loadSpots,    CONFIG.SPOTS_INTERVAL);
loop(loadProp,     CONFIG.PROP_INTERVAL);
loop(loadRbn,      CONFIG.RBN_INTERVAL);
loop(loadDxWorld,  CONFIG.DXW_INTERVAL);
loop(loadNewsline, CONFIG.NL_INTERVAL);
loop(loadContests, CONFIG.CAL_INTERVAL);
loop(loadPsk,      CONFIG.PSK_INTERVAL);
loadClubLog();
